export default __webpack_public_path__ + "static/media/voltealafuturo_1920_scania.96949045.jpg";